import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useReport } from "../../context/report";
import { useRef, useEffect, useState } from "react";
import { Button } from "primereact/button";
import { useReactToPrint } from "react-to-print";

export function EficienciaAbaixo() {
    const { data } = useReport();

    const [columnMVisible, setColumnMVisible] = useState(false);
    const [columnOVisible, setColumnOVisible] = useState(false);
    const [counter, setCounter] = useState(0);

    const ref = useRef();

    let bodyStyle = {
        borderColor: "#000",
        borderWidth: 1,
        padding: 3,
        textAlign: "center",
        width: 100 / (9 + counter)  + "%"
    }

    const handlePrint = useReactToPrint({
        content: () => ref.current
    });

    useEffect(() => {
        let manutencoes = false;
        let outros = false;

        data.dados.forEach((item) => {
            if(item.tempo_manutencao > 0) {
                manutencoes = true;
            }

            if(item.tempo_outros > 0) {
                outros = true;
            }
        });

        if(manutencoes === true && outros === true) {
            setCounter(2);
        } else if(manutencoes === true || outros === true) {
            setCounter(1);
        } else {
            setCounter(0);
        }

        setColumnMVisible(manutencoes);
        setColumnOVisible(outros);
    }, [data]);

    return (
        <div>
            <Button
                className="p-m-1"
                icon="pi pi-print"
                onClick={handlePrint}
            />
            <div ref={ref}>
                <div className="p-d-flex p-jc-center p-ai-center p-flex-column" style={{ border: "1px solid black", borderBottom: 0, padding: 8 }}>
                    <div>
                        <strong>Turma: {data.turma} - Data: {data.data}</strong>
                    </div>
                    <h4 className="p-m-2">Acompanhamento Diário dos Teares com Eficiência Abaixo de {data.eficiencia}%</h4>
                </div>
                <DataTable
                    id="my-table"
                    size="small"
                    style={{ fontSize: 15 }}
                    value={data.dados}
                >
                    <Column header="Tear" field="tear" alignHeader="center" style={bodyStyle} />
                    <Column header="Artigo" field="artigo" alignHeader="center" style={bodyStyle} />
                    <Column header="Eficiência" field="eficiencia_tear" alignHeader="center" style={bodyStyle} />
                    <Column header="Engrupagem" field="tempo_engrupagem" alignHeader="center" style={bodyStyle} />
                    <Column header="Espera" field="tempo_espera" alignHeader="center" style={bodyStyle} />
                    <Column header="Reengrupagem" field="tempo_reengrupagem" alignHeader="center" style={bodyStyle} />
                    {columnMVisible === true && (
                        <Column header="Manutenção" field="tempo_manutencao" alignHeader="center" style={bodyStyle} />
                    )}
                    {columnOVisible === true && (
                        <Column header="Outros" field="tempo_outros" alignHeader="center" style={bodyStyle} /> 
                    )}
                    <Column header="Manual" field="manual" alignHeader="center" style={bodyStyle} />
                    <Column header="Trama" field="trama" alignHeader="center" style={bodyStyle} />
                    <Column header="Urdume" field="urdume" alignHeader="center" style={bodyStyle} />
                </DataTable>
            </div>
        </div>
    )
}